<template>
  <div class="live-tool tipoff_wrap">
    <div class="item2" :style="{color: '#f10401'}" @click="LinkCompany(exId)">
      <i class="iconfont icon-zhuye"></i>
      <div>店铺</div>
    </div>
    <div class="item2" @click="inquiry" :style="{color: '#feb300'}">
      <i class="iconfont icon-liaotian"></i>
      <div>询盘</div>
    </div>
    <div class="item2 bg_tm" @click="share" :style="{color: '#fff'}">
      <i class="iconfont icon-fenxiang2"></i>
      <div>分享</div>
    </div>
    <div @click="tipoffShow=true" style="color: #fff;padding-top: .3rem;font-size:0.2rem;">举报</div>
    <van-popup v-model="tipoffShow" class="tipoff_pop" @closed="tipoffClose" :close-on-click-overlay="false">
      <div class="tipoff_title">举报</div>
      <van-dropdown-menu class="tipoff_down "  :overlay="false">  
        <div class="place" v-if="tipType==0" @click="dropOpen">请输入举报类型</div>
        <van-dropdown-item   v-model="tipType" :options="tipTypeList" ref="dropref" />
      </van-dropdown-menu>
      <van-field
        class="tipoff_content"
        v-model="tipContent"
        type="textarea"
        placeholder="请输入举报内容"
        maxlength="100"
        show-word-limit
      />
      <div class="tipoff_pop_button">
        <van-button type="default" block @click="tipoffShow=false">取消</van-button>
        <van-button type="default" block @click="submit">提交</van-button>
      </div>
    </van-popup>
    <!-- 询盘 -->
    <inquiry ref="inquiry"></inquiry>
    <!-- 分享 -->
    <liveShare ref="liveShare"></liveShare>
  </div>
</template> 

<script>
import inquiry from "@components/inquiry";
import liveShare from "@/components/live-share/index";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "live-tool2",
  components:{
    inquiry,
    liveShare,
  },
  data() {
    return {
      exId:'',
      tipoffShow: false,    //举报弹窗
      tipType:0,
      tipContent:'',         //举报内容
      tipTypeList:[
        {
          text:'虚假宣传',
          value:1
        },
        {
          text:'创意抄袭',
          value:2
        },
        {
          text:'发布违法等不良信息',
          value:3
        },
        {
          text:'骚扰',
          value:4
        },
        {
          text:'其他违规行为',
          value:5
        }
      ],
      exInfo:{},
      shareV:{
        content:'',
        poster:'',
      },
      isShareV:false
    };
  },
  computed: {
    ...mapGetters({
      viewer: "getViewer",
      viewerId: "getViewerId",
      exhibitorId:'company/getExhibitorId',
      companyId:'company/getCompanyId',
      userInfo:'getUserInfo',
      exhibitionId:'getExhibitionId'
    })
  },
  created(){
    this.exId=this.$route.query.exhibitorId;
  },
  methods: {
    ...mapActions({
      LinkCompany:'linkTo/LinkCompany',
      tipComp:'company/tipComp',
      getShareConfig:'wxShare/getShareConfig'
    }),
    // 去店铺
    goToShop() {
      this.$router.push("/shop");
    },
    //询盘点击  
    inquiry(){
      this.$refs["inquiry"].open();
    },
    //举报弹框关闭
    tipoffClose(){
      this.tipContent='';
      this.tipType=0;
    },
    //点击请选择举报内容弹出下拉框
    dropOpen(){
      this.$refs["dropref"].toggle();
    },
    //提交留言
    async submit(){
      if (this.tipType == 0) {
        this.$toast('请选择类型');
        return;
      }
      if(!this.tipContent.trim()) {
        this.$toast('请输入举报内容');
        return;
      }
      let info={
        name:this.userInfo.name||this.userInfo.nickName,
        phone:this.userInfo.phone,
      }
      let body = {
          compId: this.companyId,
          exhibitionId: this.exhibitionId,
          exhibitorId: this.exhibitorId,
          userId: this.userInfo.userId,
          userInfo:JSON.stringify(info),
          reportType: this.tipTypeList[this.tipType - 1].text,
          remark: this.tipContent.trim(),
      }
      let result =  await this.tipComp(body);
      if(result.result){
        this.$toast.success('举报成功');
        this.tipoffShow=false;
      } else {
        this.$toast.fail(result.message || '举报失败');
        this.tipoffShow=false;
      }
    },
    async getShareVal(){
      let res = await this.getShareConfig(this.exInfo.exhibitorId);
      if(res&&res){
        this.shareV=JSON.parse(res);
      }
      this.isShareV=true;
    },
    //分享点击
    async share(){
      if(!this.isShareV){
        await this.getShareVal();
      }
      let addr='';
      if(this.exInfo.province){
        addr=this.exInfo.province;
      }
      if(this.exInfo.city){
        addr+='·'+this.exInfo.city;
      }
      let opt={
        title:'给您推荐一家优质展商',
        bannerTitle:this.exInfo.compName||this.exInfo.shortName,
        subhead:addr,
        bannerUrl:this.shareV.poster?this.shareV.poster:'default',
        // bannerUrl:'default'
      }
      this.$refs['liveShare'].open(opt);
      await true
    },
    async getShareData(data){
      this.exInfo=data;
      await this.getShareVal();
      let shareData={
        title:this.shareV.content?this.shareV.content:'诚邀您参观 '+data.compName+' 线上展台',
        desc:data.summaryZh||'',
        imgUrl:data.logo
      }
      this.$nextTick(()=>{
        this.$refs.liveShare.shareTo(shareData);
      })
    },
  }
};
</script>
<style scoped lang="scss">
.live-tool {
  position: absolute;
  z-index: 103;
  bottom: 0.82rem;
  right: 0.3rem;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  width: 0.92rem;
  justify-content: center;
  .item {
    width: 0.76rem;
    height: 0.76rem;
    border-radius: 50%;
    background-color: rgba(#000, 0.4);
    text-align: center;
    line-height: 0.76rem;
    align-items: center;
    justify-content: center;
    margin-top: 0.3rem;
    img {
      transform: scale(0.5);
    }
  }
  .item2 {
    width: 0.92rem;
    height: 0.92rem;
    padding-bottom: 0.2rem;
    background: #fff;
    border-radius: 50%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    color: currentColor;
    border: 0.02rem solid currentColor;
    margin-top: 0.3rem;
    text-align: center;
    &.bg_tm{
      background: rgba(0,0,0,0.4);
      border:none;
      i{
        transform: translateY(0.05rem);
      }
    }
    i {
      transform: translateY(0.1rem);
      display: block;
      font-size: 0.6rem;
    }
    div {
      width: 100%;
      font-size: 0.2rem;
      line-height: 1;
    }
  }
  &::v-deep .tipoff_pop{
    width: 5.6rem;
    height: 5.36rem;
    padding: 0.6rem 0.35rem 0;
    background: #fff;
    border-radius: 0.06rem;
    transform: translate(-50%,-50%);
    overflow: hidden;
    .tipoff_title{
      font-size: 0.36rem;
      text-align: center;
      color: #333;
      line-height: 1;
      margin-bottom: 0.5rem;
      letter-spacing: 1px;
      padding-left: 1px;
    }
    .tipoff_down{
      height: 0.7rem;
      border:1px solid #e6e6e6;
      position: relative;
      &::after{
        display: none;
      }
      .place{
        width: 100%;
        // height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: transparent;
        color: #bfbfbf;
        // height: 0.7rem;
        // line-height: normal;
        // padding: 0.15rem 0.2rem;
        line-height: .7rem;
        padding: 0rem 0.2rem;
        font-size: 0.3rem;
      }
      
      .van-dropdown-menu__item{
        .van-dropdown-menu__title{
          padding: 0 0.2rem;
          display: block;
          line-height: 0.7rem;
          font-size: 0.3rem;
          width: 100%;
          .van-ellipsis{
            font-size: 0.3rem;
          }
          &::after{
            right: 0.2rem;
          }
        }
      }
      .van-dropdown-item{
        top:2.16rem!important;
        left: 0.35rem;
        right: 0.35rem;
        .van-popup{
          padding-top: 0.1rem;
          box-shadow: 0px 0px 8px 3px rgba(0,0,0,0.3); 
          .van-cell {
            padding: 0 0 0 0.23rem;
            line-height: 0.56rem;
            height: 0.56rem;
            color: #333;
            &.van-dropdown-item__option--active{
                background: #f2f2f2;
            }
            .van-cell__value{
              display:none;
            }
            &::after{
              display: none;
            }
          }
        }
      }
    }
    .tipoff_content{
      border:1px solid #eee;
      margin-top: 0.2rem;
        height: 1.4rem;
        padding: 0.1rem 0.2rem;
        .van-field__body{
          .van-field__control{
            min-height: 0.95rem;
            font-size: 0.3rem;
            line-height: 0.38rem;
            &::-webkit-input-placeholder { /* WebKit browsers */
                color:    #bfbfbf;
            }
            &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                color:    #bfbfbf;
            }
            &::-moz-placeholder { /* Mozilla Firefox 19+ */
                color:    #bfbfbf;
            }
            &:-ms-input-placeholder { /* Internet Explorer 10+ */
                color:    #bfbfbf;
            }
          }
        }
        .van-field__word-limit{
          line-height: 1;
          font-size: 0.24rem;
          margin-top: 0;
        }
    }
    .tipoff_pop_button{
      height: 1.01rem;
      width: 100%;
      display: flex;
      position: absolute;
      border-top: 1px solid #d2d3d5;
      left: 0;
      right: 0;
      bottom: 0;
      .van-button{
        line-height: 1rem;
        height: 1rem;
        border: none;
        border-radius: 0;
        color: #333;
        .van-button__text{
          font-size: 0.36rem;
        }
        &:first-child{
          border-right: 1px solid #d2d3d5;
        }
        &:last-child{
          color:#fe5502 ;
        }
      }
    }
  }
  
}
.img1 {
  position: relative;
  top: 0.06rem;
}
.img2 {
  position: relative;
  top: 0.02rem;
}
.z-side {
  position: relative;
  .list {
    flex: 1;
    width: 3.33rem !important;
    height: 0.92rem;
    position: absolute;
    right: 1.02rem;
    top: 0;
    .list-box {
      width: 100%;
      height: 0.92rem;
      padding-right: 0.16rem;
    }
    .item3 {
      width: 100%;
      height: 0.92rem;
      border: 0.02rem solid #e6b54a;
      border-right-color: transparent;
      background-image: url(../../assets/img/live/crown.png),
        linear-gradient(90deg, #4b1248 0%, #9e6a62 49%, #f0c27b 100%),
        linear-gradient(#2b1e08, #2b1e08);
      background-repeat: no-repeat;
      background-position: bottom right, 0% 0%;
      background-size: 0.52rem 0.52rem, auto;
      border-radius: 0.06rem;
      position: relative;
      text-align: left;
      padding: 0.1rem;
      display: flex;
      &::after {
        content: "";
        position: absolute;
        right: -0.2rem;
        top: 50%;
        margin-top: -0.1rem;
        border-width: 0.1rem;
        border-style: solid;
        border-color: transparent;
        border-left-color: #ecbe78;
      }
      .logo {
        width: 0.7rem;
        height: 0.7rem;
        border-radius: 0.02rem;
        border: 0.02rem solid #f0cc3a;
        margin-right: 0.1rem;
      }
      .content {
        width: calc(100% - 0.8rem);
        height: 0.7rem;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        p {
          font-size: 0.2rem;
          color: #fff;
          font-weight: bold;
          margin: 0;
          width: 100%;
          line-height: 0.2rem;
        }
        .txt {
          font-size: 0.16rem;
          color: #fff;
          width: 100%;
        }
        .tag {
          width: 0.6rem;
          padding: 0 0.04rem;
          height: 0.2rem;
          line-height: 0.2rem;
          display: inline-block;
          background-color: #fff;
          border-radius: 2px;
          font-size: 0.12rem;
          color: #f85b0f;
          .iconfont {
            font-size: 0.12rem;
          }
        }
      }
    }
  }
}
  
</style>
